import React from "react";
import "./LoadingSpinner.css";

type props = {
  loading: boolean;
  className?: string;
};

const LoadingSpinner: React.FC<props> = ({ loading, className }) => {
  return loading ? (
    <div className={`spinner-border custom-spinner ${className}`} role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  ) : null;
};

export default LoadingSpinner;
